import React from 'react'
import Header from './containers/Header'

import { useTranslation } from 'react-i18next'

interface AppProps {
  lang: string;
  languageToggleLink: string;
  loginUrl: string;
  logoutUrl: string;
  enableLiveChat: boolean;
}

const App: React.FC<AppProps> = ({ lang, languageToggleLink, loginUrl, logoutUrl, enableLiveChat }) => {
  const { i18n } = useTranslation()
  i18n.changeLanguage(lang)

  return (
    <div id='ch-root'>
      <Header languageToggleLink={languageToggleLink} loginUrl={loginUrl} logoutUrl={logoutUrl} enableLiveChat={enableLiveChat} />
    </div>
  )
}

export default App
